import {
    Layout,
    AppBar,
    TitlePortal,
    defaultTheme,
    defaultDarkTheme,
    CheckForApplicationUpdate,
    Menu
} from 'react-admin';
import PropTypes from 'prop-types';
import { deepmerge } from '@mui/utils';
import HelpIcon from '@mui/icons-material/Help';
import logo from '../images/skylar-cms-logo.png';

const Logo = () => (
	<img src={logo} alt="Skylar CMS Logo" style={{ marginTop: '8px', marginBottom: '8px' }} />
);

export const BrandedAppBar = () => (
	<AppBar>
		<Logo />
		<TitlePortal />
	</AppBar>
);

export const CustomMenu = () => (
    <Menu>
        <Menu.DashboardItem />
        <Menu.ResourceItems />
        <Menu.Item to="/help" primaryText="Help" leftIcon={<HelpIcon />} />
    </Menu>
);

export const AppLayout = ({ children }) => (
	<Layout appBar={BrandedAppBar} menu={CustomMenu}>
		{children}
        <CheckForApplicationUpdate />
	</Layout>
);

AppLayout.propTypes = {
	children: PropTypes.any // Array, ReactNode?
};

const appBarHeight = '76px';

const styleOverrides = {
	components: {
        MuiAppBar: {
            styleOverrides: {
                root: {
                    backgroundColor: '#1a237e',
					height: appBarHeight
                },
            },
        },
		MuiCssBaseline: {
            styleOverrides: {
                '& .RaLayout-appFrame': {
                    marginTop: appBarHeight + ' !important'
                },
            },
        },
    },
};

export const appTheme = deepmerge( defaultTheme, styleOverrides );
export const appDarkTheme = deepmerge( deepmerge( defaultDarkTheme, styleOverrides ), { palette: { mode: 'dark' } });

export default AppLayout;